import React from 'react'

import WildcatBanner from 'Pods/Shared/Banner/WildcatBanner'

function WildcatBannerCard() {
  return (
    <div className="col-12 col-sm-6 col-md-4 col-lg-3 col-xxl-2">
      <div className="content-box is-no-results-box content-box--interactive">
        <WildcatBanner
          pageName="free-listing"
          title="Earn from your 3D skills"
          subtitle="100s of freelance tasks | Surge prices | No bidding"
          benefitsAreHidden
          buttonClass="cgt-button--small"
        />
      </div>
    </div>
  )
}

export default WildcatBannerCard
